import React from 'react';
import { connect, Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';

function mapStateToProps({ locale }) {
  return {
    locale: locale.language,
    messages: locale.messages,
    key: locale.language,
  };
}

const ConnectedIntlProvider = connect(mapStateToProps)(IntlProvider);

type Props = {
  store: Object,
};

export default ({ store, ...props }: Props) => {
  return (
    <Provider store={store}>
      <ConnectedIntlProvider {...props} />
    </Provider>
  );
};



// WEBPACK FOOTER //
// ../src/client/WrappedIntlProvider.js